import { useState } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'
import ChevronCheckBox from '@components/controls/ChevronCheckBox'
import Button from '@components/Button'
import Popover from '../../../components/Popover'
import SpinnerButton from '../../../components/forms/spinner_button'

const CommentListControls = props => {
  const [popoverVisible, setPopoverVisible] = useState(false)

  const handleSelectAllCheckBoxChange = () => {
    const { onClickSelectAllCheckBox } = props
    onClickSelectAllCheckBox()
  }

  const handleSelectVisibleClick = e => {
    const { onSelectVisible } = props
    e.preventDefault()
    hidePopover()
    onSelectVisible()
  }

  const handleSelectHiddenClick = e => {
    const { onSelectHidden } = props
    e.preventDefault()
    hidePopover()
    onSelectHidden()
  }

  const togglePopoverVisibility = () => {
    setPopoverVisible(!popoverVisible)
  }

  const hidePopover = () => {
    setPopoverVisible(false)
  }

  const handleShowSelectedClick = () => {
    const { onShowSelected } = props
    onShowSelected()
  }

  const handleHideSelectedClick = () => {
    const { onHideSelected } = props
    onHideSelected()
  }

  const handlePopoverDismiss = () => {
    hidePopover()
  }

  const getPopoverContent = () => {
    if (popoverVisible) {
      return (
        <ul className="unstyled-list">
          <li>
            <Button onClick={handleSelectVisibleClick} className="button-reset">
              Select visible
            </Button>
          </li>
          <li>
            <Button onClick={handleSelectHiddenClick} className="button-reset">
              Select hidden
            </Button>
          </li>
        </ul>
      )
    }
    return null
  }

  const getShowSelectedButtonContent = () => {
    const { anySelected, awaitingBulkShowAsyncResponse } = props
    const spinWhenDisabled = awaitingBulkShowAsyncResponse
    const disabled = !anySelected || awaitingBulkShowAsyncResponse
    return (
      <SpinnerButton
        className="list-controls__item control control--spinner"
        onClick={handleShowSelectedClick}
        disabled={disabled}
        spinWhenDisabled={spinWhenDisabled}
      >
        Show selected
      </SpinnerButton>
    )
  }

  const getHideSelectedButtonContent = () => {
    const { anySelected, awaitingBulkHideAsyncResponse } = props
    const spinWhenDisabled = awaitingBulkHideAsyncResponse
    const disabled = !anySelected || awaitingBulkHideAsyncResponse
    return (
      <SpinnerButton
        className="list-controls__item control control--spinner"
        onClick={handleHideSelectedClick}
        disabled={disabled}
        spinWhenDisabled={spinWhenDisabled}
      >
        Hide selected
      </SpinnerButton>
    )
  }

  const { anySelected, allSelected } = props
  const popoverContent = getPopoverContent()
  const showSelectedButton = getShowSelectedButtonContent()
  const hideSelectedButton = getHideSelectedButtonContent()
  return (
    <div className="list-controls">
      <div className="list-controls__section">
        <div className="list-controls__item">
          <Popover
            open={popoverVisible}
            onOpenChange={setPopoverVisible}
            onDismiss={handlePopoverDismiss}
            triggerOnReferenceClick={false}
          >
            <Popover.Reference>
              <ChevronCheckBox
                checked={allSelected}
                indeterminate={anySelected && !allSelected}
                onChange={handleSelectAllCheckBoxChange}
                onClickChevron={togglePopoverVisibility}
                isOpen={popoverVisible}
              />
            </Popover.Reference>
            <Popover.Content className="popover popover--menu">{popoverContent}</Popover.Content>
          </Popover>
        </div>
        {showSelectedButton}
        {hideSelectedButton}
      </div>
    </div>
  )
}
CommentListControls.propTypes = {
  selectedIds: PropTypes.array.isRequired,
  onClickSelectAllCheckBox: PropTypes.func.isRequired,
  onSelectVisible: PropTypes.func.isRequired,
  onSelectHidden: PropTypes.func.isRequired,
  onShowSelected: PropTypes.func.isRequired,
  onHideSelected: PropTypes.func.isRequired,
  awaitingBulkShowAsyncResponse: PropTypes.bool.isRequired,
  awaitingBulkHideAsyncResponse: PropTypes.bool.isRequired,
}
CommentListControls.defaultProps = {
  selectedIds: [],
  onClickSelectAllCheckBox: noop,
  onSelectVisible: noop,
  onSelectHidden: noop,
  onShowSelected: noop,
  onHideSelected: noop,
  awaitingBulkShowAsyncResponse: false,
  awaitingBulkHideAsyncResponse: false,
}

export default CommentListControls
